// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__oSe5J","inputWrap":"styles_inputWrap__1fBxx","input":"styles_input__1e0t7"};